import React from "react"
import Navbar2 from "./Navbar2"
import FooterNM from "./Footer"

import "../../assets/css/main.scss"

import GoogleTagManager from "../GoogleTagManager/GoogleTagManager"

const Layout = ({ children, lang, bg, lines }) => {
  return (
    <>
      <Navbar2 lang={lang} bg={bg} />
      <GoogleTagManager />
      {children}
      <FooterNM lang={lang} background={"#1d2128"} lines={lines} />
    </>
  )
}

export default Layout
